import { IAuthorization } from "Common/Interfaces";
import { baseAPI } from "../BaseAPI";
import { SERVICE_TAG_TYPES } from "../Constants";

const controller = "authorization";
export const authorizationAPI = baseAPI.injectEndpoints({
  endpoints: (build) => ({
    getAuthorization: build.query<IAuthorization, unknown>({
      query: () => `${controller}`,
      providesTags: () => [{ type: SERVICE_TAG_TYPES.AUTHORIZATION }],
    }),
    setIsAccepted: build.mutation<void, boolean>({
      query:(isAcceptedTerms)=>({
        url:`${controller}/terms-and-conditions`,
        method:"PUT",
        body:{isAcceptedTerms}
      }),
      invalidatesTags:[SERVICE_TAG_TYPES.AUTHORIZATION]
    })
  }),
  overrideExisting: false,
});

export const { useGetAuthorizationQuery, useSetIsAcceptedMutation } = authorizationAPI;
